import React from 'react';
import { Icon } from 'antd-mobile';
import PDFJS from 'pdfjs-dist/build/pdf.js';

class ExplodedView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            srcPath: '',
            pdf: undefined,
            loading: false,
            zoomIn: true,
            currentRotate: 0,
        };
    }

    checkNStartLoad = (newProps) => {
        if (newProps.path == this.state.srcPath) {
            return;
        }
        this.setState({
            srcPath: newProps.path,
            loading: true,
            zoomIn: true,
            currentRotate: 0,
        });
    };

    componentWillReceiveProps(newProps) {
        this.checkNStartLoad(newProps);
    }

    shouldComponentUpdate(newProps, newState) {
        if (newState.loading != this.state.loading) {
            return true;
        }
        if (newState.zoomIn != this.state.zoomIn) {
            return true;
        }
        // if (newState.currentRotate != this.state.currentRotate) {
        //     return true;
        // }
        return false;
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.loading) {
            // 下载 pdf
            if (!this.state.srcPath) {
                return;
            }

            PDFJS.GlobalWorkerOptions.workerSrc = 'js/pdf/pdf.worker.js';
            PDFJS.getDocument(this.state.srcPath).then((pdf) => {
                // 下载完成
                this.setState({
                    pdf: pdf,
                    loading: false,
                });
            }).catch((data)=>{
                console.log(data)
                this.setState({
                    loading: false,
                });
            });

        }

        if (!this.state.loading) {
            if (!this.state.pdf) {
                return;
            }

            // 展示 pdf 页面
            if (this.state.zoomIn) {
                this.pdfShowPage(this.state.pdf);
            } else {
                this.pdfShowFirstPage(this.state.pdf);
            }
        }
    }

    pdfShowFirstPage = (pdf) => {
        //用 promise 获取页面
        pdf.getPage(1).then((page) => {
            let scale = 4;
            let viewport = page.getViewport(scale);
            //
            //  准备用于渲染的 canvas 元素
            //
            let canvas = document.getElementById('the-canvas-1');
            if (!canvas) {
                return;
            }
            let context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            //
            // 将 PDF 页面渲染到 canvas 上下文中
            //
            let renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext);
        });
    };

    pdfShowPage = (pdf) => {
        for(let i = 1;i<=pdf.numPages;i++) {
            pdf.getPage(i).then((page) => {
                let scale = 4;//缩放倍数，1表示原始大小
                let viewport = page.getViewport(scale);
                let canvas = document.getElementById('the-canvas-' + page.pageNumber);
                if (!canvas) {
                    return;
                }
                let context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                let renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                page.render(renderContext);
            });
        }
    };

    render() {
        const pdfContainerClass = this.state.zoomIn ? 'iframeon' : 's';
        let pdfDom = (<Icon type='loading'/>);
        if (!this.state.loading) {
            if (!this.state.pdf) {
                return '';
            }

            let canvasDomList = [];
            for(let i = 1; i <= this.state.pdf.numPages; i++) {
                const id = 'the-canvas-' + i;
                canvasDomList.push(
                    <canvas
                        key={i}
                        id={id}
                        className="the-canvas class"
                    />
                );

                if (!this.state.zoomIn) {
                    break;
                }
            }

            pdfDom = (
                <div className={pdfContainerClass}>
                    <div className="pdfContainer">
                        {
                            canvasDomList.map((dom) => {
                                return dom
                            })
                        }
                    </div>
                </div>
            )
        }

        return (
            <div>{pdfDom}</div>
        )
    }
}
export default ExplodedView;


// WEBPACK FOOTER //
// ./src/components/ExplodedView.js